

import React from 'react';
import { Box, Typography } from '@mui/material';
import { Clock3 } from 'lucide-react';

const OpeningHoursDisplay = ({ openingHours }) => {
  if (!Array.isArray(openingHours) || openingHours.length === 0) return null;

  const days = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
  const groups = [];

  openingHours.forEach(({ dayOfWeek, open, close }) => {
    const key = `${open}-${close}`;
    const existing = groups.find(g => g.key === key);
    if (existing) {
      existing.days.push(dayOfWeek);
    } else {
      groups.push({ key, open, close, days: [dayOfWeek] });
    }
  });

  groups.forEach(g => {
    g.days.sort((a, b) => days.indexOf(a) - days.indexOf(b));
  });

  return (
    <Box sx={{ mb: 2 }}>
      {groups.map((group, idx) => {
        const range = group.days.length === 1
          ? group.days[0]
          : `${group.days[0]} – ${group.days[group.days.length - 1]}`;
        return (
          <Typography key={idx} variant="body2">
            <Clock3 size={16} style={{ verticalAlign: 'middle', marginRight: 4 }} />
            {range}: {group.open} - {group.close}
          </Typography>
        );
      })}
    </Box>
  );
};

export default OpeningHoursDisplay;